import React from "react";
import { XIcon } from "lucide-react";

const Footer = () => {
  return (
    <footer className="z-10 bg-[#1a1a2e] text-[#00F0FF] py-10 border-t border-[#00F0FF] mt-10">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold text-[#FF007F] mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-[#FF007F] transition">Home</a></li>
            <li><a href="/about" className="hover:text-[#FF007F] transition">About Us</a></li>
            <li><a href="/contact" className="hover:text-[#FF007F] transition">Contact Us</a></li>
            <li><a href="/categories" className="hover:text-[#FF007F] transition">Categories</a></li>
            <li><a href="/search" className="hover:text-[#FF007F] transition">Search games</a></li>
          </ul>
        </div>

        {/* Informational Links */}
        <div>
          <h3 className="text-lg font-bold text-[#FF007F] mb-3">Explore Browser Games</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/about-browser-games" className="hover:text-[#FF007F] transition">What Are Browser Games?</a></li>
            <li><a href="/best-browser-games" className="hover:text-[#FF007F] transition">Best Browser Games 2025</a></li>
            <li><a href="/free-games" className="hover:text-[#FF007F] transition">Free Games – No Downloads</a></li>
            <li><a href="/html5-games" className="hover:text-[#FF007F] transition">Top HTML5 Games</a></li>
          </ul>
        </div>

        {/* Social */}
        <div>
          <h3 className="text-lg font-bold text-[#FF007F] mb-3">Follow Us</h3>
          <div className="flex justify-center md:justify-start space-x-4 mt-2">
            <a
              href="https://x.com/browserarena"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#FF007F] transition flex items-center space-x-1"
            >
              <XIcon size={20} />
              <span className="text-sm hidden sm:inline">Twitter</span>
            </a>
            {/* Add more social links here if needed */}
          </div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className="mt-10 text-center text-sm text-gray-400 space-y-1">
        <p>&copy; 2024 <span className="text-[#00F0FF]">BrowserArena.com</span> | All rights reserved.</p>
        <p>
          <a href="/privacy-policy" className="hover:text-[#FF007F]">Privacy Policy</a> &nbsp;|&nbsp;
          <a href="/terms-conditions" className="hover:text-[#FF007F]">Terms & Conditions</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
